module.exports = ".ck.ck-block-toolbar-button{transform:translateX(calc(var(--ck-spacing-large)*-1))}"